




import { AppPlatformEnums } from "@/enums/app";
import { AppStore } from "@/store/namespace";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class WtThemeIcon extends Vue {
  @Prop({ type: String }) themeImg1: string; // 主题一样式
  @Prop({ type: String }) themeImg2: string; // 主题二样式
  @Prop({ type: Boolean, default: true }) enable: string; // 是否开启
  @Prop({ type: String }) platformProp: string; // 平台属性，优先使用

  @AppStore.State platform: string;

  get iconBgStyle() {
    return this.enable
      ? `background: url(${this.themeImg1}) no-repeat center / 100% 100% `
      : "";
  }
}
